import { ADD_NEW, GET_NEXT, EMPTY_CURRENT } from "./constants.js";

const _ = require("lodash");

export default {
  [ADD_NEW](state, { message, priority }) {
    state.pendingNotifications.push({ message, priority });
  },
  [GET_NEXT](state) {
    if (
      _.isEmpty(state.currentNotification) &&
      !_.isEmpty(state.pendingNotifications)
    ) {
      state.currentNotification = state.pendingNotifications.shift();
    }
  },
  [EMPTY_CURRENT](state) {
    state.currentNotification = {};
  }
};
